export default function getResource(label) {
    const resources = {
        compareProducts: 'Comparer les articles',
        emptySlot: 'Vide',
        colors: 'Couleurs',
        color: 'Couleur',
        sizes: 'Formats',
        size: 'format',
        standardSize: 'Format standard : ',
        ratingsAndReviews: 'Évaluations et commentaires',
        prosMentioned: 'Pour mentionnés',
        consMentioned: 'Inconvénients mentionnés',
        overview: 'Aperçu',
        ingredients: 'Ingrédients',
        pickupAndDelivery: 'Ramassage et livraison',
        showAll: 'Afficher tout'
    };

    return resources[label];
}
